/**
 * URL du site courant (Netlify Functions en same-origin).
 * Ne pas utiliser REACT_APP_BASE_URL ici : en `netlify dev` ça forcerait des appels
 * vers la prod et le navigateur bloquerait (CORS sur le preflight).
 */
export const BASE_URL =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BASE_URL || "";

export const N8N_CONFIG_URL =
  "https://n8n.prestigiousyachting.com/webhook/getConfigToys";

/** Same-origin proxy → n8n (évite CORS navigateur sur les webhooks). */
export const N8N_ORDER_CONFIRMATION_URL = `${BASE_URL}/.netlify/functions/createOrderToys`;

export const N8N_AVAILABILITY_URL =
  "https://n8n.prestigiousyachting.com/webhook/getToysAvailability";
